import { connect } from 'react-redux';
import { change } from 'redux-form';
import _get from 'lodash/get';
import { chatActions } from '@lifesize/nucleus';
import { Analytics } from '@lifesize/web-clients-core';
import { selectConversationContactDialString, setChatMode } from 'actions/Chat';
import ChatMessageInput from 'components/Chat/ChatMessageInput';
import { TrackEvents } from 'utils/analytics';

const mapStateToProps = (state, ownProps) => {
  const formValues = _get(state, 'app.form.chat.values', {});
  const contact = _get(ownProps, 'conversation.contact', {});
  // Disable input for out-of-call meetings
  const isReadOnly = contact.isMeeting && !ownProps.isInCall;

  return {
    formValues,
    isReadOnly
  };
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onMessageSend: (field, values) => {
      const message = values[field];
      Analytics.track(TrackEvents.SendChat, { isInCall: !!ownProps.isInCall });

      // conversation is provided by Parent component

      // setChatMode() sets 'app.chat.conversationMode' defaults to 'current', but also could be 'search' or 'new' it determines the display state of the chat header and window
      dispatch(setChatMode());
      // selects the current chat by dialstring
      dispatch(selectConversationContactDialString(_get(ownProps, 'conversation.contact.dialString')));
      dispatch(
        chatActions.sendMessage(
          message,
          ownProps.chatContact || { uuid: _get(ownProps, 'conversation.conversationId') }
        )
      );

      // reset the chat field
      dispatch(change('chat', field, ''));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatMessageInput);
